import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import {
  buildLimitsLayout,
  LIMIT_GAMES,
  limitsDialogSaveRef,
} from "@/v2/kits/limits";

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!limitsDialogSaveRef.value) return;
  await limitsDialogSaveRef.value();
}

export const limitsTab: ContentTab = {
  id: "limits",
  label: "Limits",
  save,
  children: [
    {
      type: "component",
      component: () => import("@/v2/kits/limits/components/LimitsDialogTab.vue"),
      props: {
        limitsEntity: "CATEGORY",
        limitsLayout: buildLimitsLayout({
          showMinStake: false,
          games: [LIMIT_GAMES.GLOBAL, LIMIT_GAMES.LIVE, LIMIT_GAMES.PREMATCH],
        }),
      },
    },
  ],
};
